import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL =
  import.meta.env.VITE_SUPABASE_URL || 'https://wrfpvgdwihjlymzykueg.supabase.co';
const SUPABASE_PUBLISHABLE_KEY =
  import.meta.env.VITE_SUPABASE_ANON_KEY ||
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6IndyZnB2Z2R3aWhqbHltenlrdWVnIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDM3ODg2MzAsImV4cCI6MjA1OTM2NDYzMH0.H8HCvPoBhKV_ZOQjl829P7X15QnKwH0qIzi9K17CAo0';

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);
